import { createFileRoute } from '@tanstack/react-router';
import { OrderListRoute, validateOrderListSearch } from './-order-list-route';

export const Route = createFileRoute('/_order-list/')({
  validateSearch: validateOrderListSearch,
  component: OrderListRoute,
});
